export const updateObject = (oldValue,updatedValues) =>{
    return {
        ...oldValue,
        ...updatedValues
    };
};


// WEBPACK FOOTER //
// ./src/store/utility.js